import { useDebugValue, useMemo } from 'react';
import { useToken } from 'reakit-system/useToken';
import Color from 'color';
import { isLight } from './isLight.js';
import '../palette.js';
import { getPalette } from './palette.js';
import './ref.js';

function contrastRatio(color1, color2) {
  return Color(color1).contrast(Color(color2));
}

function useContrastRatio(color1, color2) {
  useDebugValue(color1 + " - " + color2);
  return useMemo(function () {
    return contrastRatio(color1, color2);
  }, [color1, color2]);
}

function contrast(color) {
  if (!color) return function () {
    return undefined;
  };

  if (typeof color === "function") {
    return function (palette) {
      return contrast(color(palette))(palette);
    };
  }

  var colorIsLight = isLight(color);
  return function (palette) {
    if (colorIsLight) return getPalette(palette, "black") || "black";
    return getPalette(palette, "white") || "white";
  };
}

function useContrast(color) {
  useDebugValue(color);
  var palette = useToken("palette");
  return useMemo(function () {
    return contrast(color)(palette);
  }, [color, palette]);
}

export { contrast, contrastRatio, useContrast, useContrastRatio };